import { render, staticRenderFns } from "./moneySupervision.vue?vue&type=template&id=72fd270c&scoped=true"
import script from "./moneySupervision.vue?vue&type=script&lang=js"
export * from "./moneySupervision.vue?vue&type=script&lang=js"
import style0 from "./moneySupervision.vue?vue&type=style&index=0&id=72fd270c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fd270c",
  null
  
)

export default component.exports